import React from 'react'
import { Outlet } from 'react-router-dom'

import TutorUpcomingClasses from './TutorUpcomingClasses'
import TutorPastClasses from './TutorPastClasses'

const DashboardTutorLayout = () => {
  return (
    <>
      <Outlet />
      <aside>
        <TutorUpcomingClasses />
        <TutorPastClasses />
      </aside>
    </>
  )
}

export default DashboardTutorLayout
